import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const TimerPage = lazy(() => import('./pages/TimerPage'));
const MobileTimePage = lazy(() => import('./pages/MobileTimePage'));
const GeolocationPage = lazy(() => import('./pages/GeolocationPage'));
const TimesheetApprovalsPage = lazy(() => import('./pages/TimesheetApprovalsPage'));
const TimesheetCompliancePage = lazy(() => import('./pages/TimesheetCompliancePage'));
const PayrollHoursPage = lazy(() => import('./pages/PayrollHoursPage'));
const UtilizationPage = lazy(() => import('./pages/UtilizationPage'));

export const TimeAdvancedRoutes: RouteObject = {
  path: 'time-advanced',
  handle: { crumb: 'Advanced Time & Compliance' },
  element: <ModuleGuard moduleId="projects.time-advanced" />,
  children: [
    { index: true, element: <Navigate to="timer" replace /> },
    { path: 'timer', element: <TimerPage />, handle: { crumb: 'Timer' } },
    { path: 'mobile-time', element: <MobileTimePage />, handle: { crumb: 'Mobile Time' } },
    { path: 'geolocation', element: <GeolocationPage />, handle: { crumb: 'Geolocation' } },
    { path: 'timesheet-approvals', element: <TimesheetApprovalsPage />, handle: { crumb: 'Timesheet Approvals' } },
    { path: 'timesheet-compliance', element: <TimesheetCompliancePage />, handle: { crumb: 'Timesheet Compliance' } },
    { path: 'payroll-hours', element: <PayrollHoursPage />, handle: { crumb: 'Payroll Hours' } },
    { path: 'utilization', element: <UtilizationPage />, handle: { crumb: 'Utilization' } },
  ],
};
